/** Vai trò cơ sở của tài khoản đang đăng nhập (user.info.reception_role) */
export const receptionRole = (): string | undefined => {
  try {
    const u = JSON.parse(localStorage.getItem('user') || '{}');
    return (u?.info ?? u)?.reception_role ?? undefined;
  } catch {
    return undefined;
  }
};

/** Kỹ thuật viên xem dịch vụ của khách, không xem giá, báo giá (PA, P12) */
export const isTechnicianAccount = () => receptionRole() === 'technician';
